import * as AuthToken from '../../../helpers/auth/token';
import router from '../../../router';

const { KLICKART_AUTH_URI } = process.env;

export const authInit = ({ rootState }) => {
  const { redirect } = rootState.route.query;
  const { locale } = rootState.route.params;
  let { token } = rootState.route.query;

  if (!token) {
    window.location = KLICKART_AUTH_URI;
    return;
  }

  token = token.replace(/\s/g, '+');

  AuthToken.set(token);

  if (redirect) {
    window.location = redirect;
    return;
  }

  router.push({ name: 'index', params: { locale } });
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/auth/actions.js
 **/